const titles = {
    news: 'titles.news',
    subTitleNews: 'titles.subTitleNews',
    events: 'titles.events',
    subTitleEvents: 'titles.subTitleEvents',
    partners: 'titles.partners',
    subTitlePartners: 'titles.subTitlePartners',
    aboutUs: 'titles.aboutUs',
    team: 'titles.team',
    history: 'titles.history',
    tree: 'titles.tree',
    subTitleTree: 'titles.subTitleTree',
    treeWhatBelive: 'titles.treeWhatBelieve',
    treeManifest: 'titles.treeManifest',
    services: 'titles.services',
    subTitleServices: 'titles.subTitleServices',
    training: 'titles.training',
    subTitleTraining: 'titles.subTitleTraining',
    galeria: 'titles.galeria',
    subTitleGaleria: 'titles.subTitleGaleria',
    interview: 'titles.interview',
    subTitleInterviews: 'titles.subTitleInterviews',
    benefits: 'titles.benefits',
    ourApproach: 'titles.ourApproach',
    sources: 'titles.sources',
    therapySessions: 'titles.therapySessions',
    therapySessionTitle: 'titles.therapySessionTitle',
    poznajnas: 'titles.poznajnas',
    data: 'titles.data',
    authors: 'titles.authors',
    czytaj: 'titles.czytaj',
    czytajDalej: 'titles.czytajDalej',
    legends: 'titles.legends',
}

export default titles;